<template>
  <a v-if="!inScud" @click="sendXml">
    <img :src="iconPath('v_scud.svg')" alt="" class="icon-pdf">
    Передать в СКУД
  </a>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import mainMixin from '@/common/mixins/mainMixin'

export default {
  name: 'SendToScudButton',

  mixins: [mainMixin],

  props: {
    applicationId: Number,
    personalId: Number,
    transportId: Number,

    inScud: {
      type: Boolean,
      default: true
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    transportIndex: {
      type: Number,
      default: 0
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    },

    async sendXml($event) {
      $event.target.disabled = true;
      ApiClient.sendToScud({
        appId: this.applicationId ? parseInt(this.applicationId) : null,
        visitorId: this.personalId ? parseInt(this.personalId) : null,
        transportId: this.transportId ? parseInt(this.transportId) : null
      })
        .then((result) => {
          if (result.data.status === 'success') {
            this.visitor.transports[this.transportIndex].inScud = true;
          } else if (result.data.status === 'fail') {
            alert(result.data.message ?? 'Не удалось передать в СКУД');
          }
          $event.target.disabled = false;
        });
    }
  }

}
</script>

<style scoped>

</style>
